import React from "react";
import { servicesInfo } from "./data";
import Modal from "../../../parts/modal-new";
import SvgIcon from "../../../parts/SvgIcon";

const InfoModal = ({ service }) => {
  const data = servicesInfo[service] || null;

  if (!data) return;
  const getBriefLines = (brief, briefItems = false) => {
    if (Array.isArray(brief))
      return brief.map((line, i) => (
        <p
          className="p5"
          style={i !== brief.length - 1 ? { marginBottom: "0.25rem" } : null}
        >
          {line}
        </p>
      ));
    if (!briefItems) return <p className="p5">{brief}</p>;
    return [
      <p className="p5" style={{ marginBottom: "0.25rem" }}>
        {brief}
      </p>,
      <ol className="opacity-70 list-inside mb-8">
        {briefItems.map((item) => (
          <li className="mb-1 list-disc text-[0.75rem]">{item}</li>
        ))}
      </ol>,
    ];
  };
  const boldInitLine = (line) => {
    if (!line.includes(":")) return line;

    const splitted = line.split(":");
    return (
      <>
        <span className={splitted[1] ? "font-semibold" : undefined}>
          {splitted[0]}:
        </span>{" "}
        {splitted[1]}
      </>
    );
  };
  const getRequirementLines = (requirements) =>
    requirements.map((requirement) => {
      return (
        <>
          <p className="p5">
            <SvgIcon src={"/img/new-icons/check-circle.svg"} />
            {boldInitLine(requirement.title || requirement)}
          </p>
          {requirement.items && (
            <ol className="opacity-70 list-inside  ml-8">
              {requirement.items?.map((item) => (
                <li key={item} className="mb-1 list-disc text-[0.75rem]">
                  {boldInitLine(item)}
                </li>
              ))}
            </ol>
          )}
        </>
      );
    });

  return (
    <Modal title={data.title} className="service-modal">
      <div className="body">
        <aside>
          <img src={data.img} alt="service" />
          <p>{data.title}</p>
          <p className="opacity-60 text-[0.875rem]">
            ${data.price} USD{" "}
            {data.title === "App Store Listing" && (
              <span>one time (and $100/year to Apple)</span>
            )}
          </p>
          <div className="flex gap-2 items-center mt-4">
            <a
              role="button"
              data-button-type="primary"
              href={data.link}
              target="_blank"
              className="flex-grow "
            >
              Buy Now
            </a>
            {data.previewLink && (
              <a
                role="button"
                data-button-type="outline"
                href={data.previewLink}
                target="_blank"
              >
                Preview Examples
              </a>
            )}
          </div>

          {/* {data.chips && (
            <footer>
              <div>{data.chips[0]}</div>
            </footer>
          )} */}
          {data.footer && (
            <footer>
              <p className="p2">{data.footer.text}</p>
              <a
                role="button"
                data-button-type="outline"
                href={data.footer.link}
              >
                <span>Request Now</span>
              </a>
            </footer>
          )}
        </aside>
        <section>
          <h4>Description</h4>
          {getBriefLines(data.brief, data.briefItems)}

          {data.chips?.length > 0 &&
            data.chips.map((chip) => (
              <span key={chip} className="chip info">
                {chip}
              </span>
            ))}
          {data.whatyouget && (
            <>
              <h4>What you get</h4>
              {data.whatyouget?.map((item) => (
                <p className="p5">
                  <SvgIcon
                    src="/img/new-icons/check-circle.svg"
                    noFilterOnLight={true}
                  />
                  {item}
                </p>
              ))}
            </>
          )}
          {data.packages && !data.packages.list && (
            <>
              <h4>Available Packages</h4>
              <div className="flex gap-4 items-center mb-6 bg-[--white-05] rounded-[--border-radius] p-4">
                {data.packages.bronze && (
                  <div className="flex-grow">
                    <h5>BRONZE - $150</h5>
                    {data.packages.bronze.map((item) => (
                      <p className="p5">
                        <SvgIcon
                          src="/img/new-icons/check-circle.svg"
                          noFilterOnLight={true}
                        />
                        {item}
                      </p>
                    ))}
                  </div>
                )}
                {data.packages.silver && (
                  <div className="flex-grow">
                    <h5>SILVER - $220 (BEST VALUE)</h5>
                    {data.packages.silver.map((item) => (
                      <p className="p5">
                        <SvgIcon
                          src="/img/new-icons/check-circle.svg"
                          noFilterOnLight={true}
                        />
                        {item}
                      </p>
                    ))}
                  </div>
                )}
                {data.packages.gold && (
                  <div className="flex-grow">
                    <h5>GOLD - $400</h5>
                    {data.packages.gold.map((item) => (
                      <p className="p5">
                        <SvgIcon
                          src="/img/new-icons/check-circle.svg"
                          noFilterOnLight={true}
                        />
                        {item}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
          {data.packages?.list && (
            <>
              <h4>Available Packages</h4>
              <div>
                {data.packages.list.map((item) => (
                  <p className="p5">
                    <SvgIcon
                      src="/img/new-icons/check-circle.svg"
                      noFilterOnLight={true}
                    />
                    {item}
                  </p>
                ))}
              </div>
            </>
          )}
          <h4 className="mt-6">Requirements</h4>
          {data.requirementSubline && (
            <p className="p5 subline">{data.requirementSubline}</p>
          )}
          {getRequirementLines(data.requirements)}
          <h4 className="mt-8">Timeline</h4>
          <ul>
            {data.timeline.map((step, i) => (
              <li key={step.phase}>
                <span>{i + 1}</span>
                <div>
                  <div>
                    <p>{step.phase}</p>
                    <p className="p5">{step.time}</p>
                  </div>
                  <p>{step.upTo}</p>
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </Modal>
  );
};

export default InfoModal;
